import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').Text}
 */
const Text = ({
    heading,
    modulePaddingClasses = '',
    text
}) => {
    return (
        <section className='module-text'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid'>
                    <div className='hidden sm:block sm:w-4/12 lg:w-3/12' />

                    <div className='w-full sm:w-8/12 layout-grid-col'>
                        <div>
                            {heading && (
                                <h2 className='type-style-heading sm:w-5/8'>{heading}</h2>
                            )}

                            {text && (
                                <div
                                    className='rich-text type-style-body mt-8 sm:mt-10 sm:w-4/8'
                                    dangerouslySetInnerHTML={{ __html: text }} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Text;
